/** Canonical border + glow for card containers. Do not use on buttons or inputs. */
export const cardBorderClassName =
  "border border-[#8a2be2]/20 shadow-[0_8px_24px_-12px_rgba(138,43,226,0.25)] hover:border-[#8a2be2]/40 transition-colors";
